import { Chip } from '@material-ui/core';
import makeStyles from '@material-ui/core/styles/makeStyles';
import React from 'react';

const useStyle = makeStyles(() => ({
  chip: {
    backgroundColor: '#192541',
  },
}));

export interface IItemProps {
  label: string;
  value: any | any[];
  alias?: any | any[];
}

const ReturnAlias = ({ label, alias, value }: IItemProps) => {
  const classes = useStyle({});
  const obj = alias.find((i: any) => i.value === value);
  if (!obj && !value) return null;
  if (!obj) return <Chip variant='outlined' className={classes.chip} label={`${label}: ${value}`} />;
  return <Chip variant='outlined' className={classes.chip} label={`${label}: ${obj.label}`} />;
};

const Item = ({ label, value, alias }: IItemProps) => {
  const classes = useStyle({});
  if (value && Array.isArray(value) && value.length > 0) {
    return (
      <>
        {alias ? (
          value.map((i: any) => <ReturnAlias key={i} label={label} alias={alias} value={i} />)
        ) : (
          <p>
            {value.map((i: any) => (
              <Chip variant='outlined' className={classes.chip} key={i} label={`${label}: ${i}`} />
            ))}
          </p>
        )}
      </>
    );
  }

  if (value && !Array.isArray(value)) {
    return (
      <>
        {alias ? (
          <ReturnAlias label={label} alias={alias} value={value} />
        ) : (
          <Chip variant='outlined' className={classes.chip} label={`${label}: ${value}`}></Chip>
        )}
      </>
    );
  }

  return null;
};
export default Item;
